import { render, staticRenderFns } from "./community_text.vue?vue&type=template&id=b5af29c0&scoped=true&"
import script from "./community_text.vue?vue&type=script&lang=js&"
export * from "./community_text.vue?vue&type=script&lang=js&"
import style0 from "./community_text.vue?vue&type=style&index=0&id=b5af29c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5af29c0",
  null
  
)

export default component.exports